import api from "./api";
import API_ROUTES from "./apiRoutes";
import { toast } from "react-toastify";

const handleError = (error, fallback) => {
  const message = error?.data?.message || error?.data?.error || error?.message || fallback;
  toast.error(message);
  throw error;
};

export const listParkingSlots = async (params = {}) => {
  try {
    const res = await api.get(API_ROUTES.parking.list, { params });
    return res.data;
  } catch (error) {
    handleError(error, "Failed to load parking slots");
  }
};

export const createParkingSlot = async (payload) => {
  try {
    const res = await api.post(API_ROUTES.parking.create, payload);
    toast.success("Parking slot created");
    return res.data;
  } catch (error) {
    handleError(error, "Failed to create parking slot");
  }
};

export const updateParkingSlot = async (slotId, payload) => {
  try {
    const res = await api.put(API_ROUTES.parking.details(slotId), payload);
    toast.success("Parking slot updated");
    return res.data;
  } catch (error) {
    handleError(error, "Failed to update parking slot");
  }
};

export const assignParkingSlot = async (slotId, payload) => {
  try {
    const res = await api.post(API_ROUTES.parking.assign(slotId), payload);
    toast.success("Parking slot assigned");
    return res.data;
  } catch (error) {
    handleError(error, "Failed to assign parking slot");
  }
};

export const unassignParkingSlot = async (slotId) => {
  try {
    const res = await api.post(API_ROUTES.parking.unassign(slotId));
    toast.success("Parking slot unassigned");
    return res.data;
  } catch (error) {
    handleError(error, "Failed to unassign parking slot");
  }
};

export const deleteParkingSlot = async (slotId) => {
  try {
    const res = await api.delete(API_ROUTES.parking.delete(slotId));
    toast.success("Parking slot removed");
    return res.data;
  } catch (error) {
    handleError(error, "Failed to remove parking slot");
  }
};

export const generateParkingSlots = async (payload) => {
  try {
    const res = await api.post(API_ROUTES.parking.generate, payload);
    toast.success("Parking slots generated");
    return res.data;
  } catch (error) {
    handleError(error, "Failed to generate parking slots");
  }
};
